import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useSubmenuSide } from '../../../../hooks/useSubMenuSide';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import classes from './Action.module.css';

const Action = ({ text, onClick, children = [], isTitle, closeMenu, level = 0 }) => {

  const [openPopup, setOpenPopup] = useState(false);
  const buttonRef = useRef(null);
  const subMenuRef = useRef(null);
  const hasChildren = useMemo(() => React.Children.toArray(children).filter((child) => React.isValidElement(child)), [children])?.length > 0;
  const side = useSubmenuSide(buttonRef, subMenuRef, openPopup, hasChildren);

  const handleClickAction = (e) => {
    e.stopPropagation();
    if (!hasChildren) {
      onClick && onClick();
      closeMenu && closeMenu();
    }
    else
      setOpenPopup((prev) => !prev);
  };

  return (
    <div className={classes.Action}>
      <div className={!isTitle ? classes.ActionButton : classes.TitleName} onClick={handleClickAction} ref={buttonRef}>
        <p className={classes.NameAction}>{text}</p>
        {hasChildren && <Icon name={iconsList.arrowTriangular} size={13} />}
      </div>

      {openPopup &&
        <div ref={subMenuRef} className={`${classes.SubActions} ${classes[side]}`}>
          {React.Children.map(children, (child) =>
            child ? React.cloneElement(child, { closeMenu, level: level + 1, }) : null
          )}
        </div>
      }
    </div>
  );
};

export default Action;
